import { useDialog } from "@shared/features/dialog/useDialog";
import { useMobileMenu } from "@shared/features/mobileMenu/useMobileMenu";
import { usePlatform } from "@platform/PlatformContext";
import { useFetchUserCircles } from "@platform/hooks/useFetchUserCircles";
import { useUserCircle } from "@platform/hooks/useUserCircle";
import { useUserTimezoneOption } from "@platform/hooks/useUserTimezoneOption";
import { ProgramCircle } from "./ProgramCircle";
import { useProgram } from "../../hooks/useProgram";
import { programEventBus } from "../../program.events";

export function ProgramCircleContainer() {
  const { isAddToCalendarDisabled, isChatDisabled } = usePlatform();

  const { program } = useProgram();

  const circle = useUserCircle();

  const userTimezoneOption = useUserTimezoneOption();

  const { closeMobileMenu } = useMobileMenu();

  const { isLoading: isLoadingCircles } = useFetchUserCircles();

  const { openDialog } = useDialog();

  const handleOpenCircleDialog = () => {
    openDialog("circle");

    if (program && circle && program.id && circle.id) {
      programEventBus.emitEvent("program:circleModal:open", {
        programId: parseInt(program.id, 10),
        circleId: parseInt(circle.id, 10),
      });
    }

    closeMobileMenu();
  };

  const handleOpenAddCalendarEventsDialog = () => {
    openDialog("addCalendarEvents");

    if (program && circle && program.id && circle.id) {
      programEventBus.emitEvent("program:addToCalendarModal:open", {
        programId: parseInt(program.id, 10),
        circleId: parseInt(circle.id, 10),
      });
    }

    closeMobileMenu();
  };

  const handleOpenChatDialog = () => {
    openDialog("chat");

    closeMobileMenu();
  };

  return (
    <ProgramCircle
      circle={circle}
      isLoading={isLoadingCircles}
      isAddToCalendarDisabled={isAddToCalendarDisabled ?? false}
      isChatDisabled={isChatDisabled ?? false}
      userTimezone={userTimezoneOption ?? undefined}
      onOpenCircleDialog={handleOpenCircleDialog}
      onOpenAddCalendarEventsDialog={handleOpenAddCalendarEventsDialog}
      onOpenChatDialog={handleOpenChatDialog}
      scheduledEngagementStartDate={program?.scheduled_engagement_start_date}
    />
  );
}

export default ProgramCircleContainer;
